
import list from './scriptures.list';

export default {
  list,
};



// WEBPACK FOOTER //
// ./src/@utils/scriptures/index.js